import {
  isDepartmentTab,
  LEADERSHIP_TAB_IDS,
  pagePath,
} from '@/navigation/page-registry';

export type LeadershipTabId = (typeof LEADERSHIP_TAB_IDS)[number];

export { LEADERSHIP_TAB_IDS };

export function isLeadershipTab(tab: string): boolean {
  return isDepartmentTab(tab, 'executive');
}

export function leadershipPath(tab: string): string {
  return pagePath(tab) ?? `/leadership/${tab}`;
}
